import $ from 'jquery';

function ArticlesIppInit() {
  var selector = '.articles-select-ipp';
  $(selector).change(function () {
    $(this).parent().submit();
  })
}

function ArticlesGalleryLoaderInit() {
  var selector = '.gallery-loader';
  var container = '#generated_gallery';
  var demandedSelector = '.demanded-gallery';
  $(selector).click(function () {
    var galleryId = $(this).attr("data-gallery-id");
    var galleryItemId = $(this).attr("data-gallery-item-id");
    $.ajax({
      type: "POST",
      url: '/gallery/ajax/demand',
      data: {galleryId: galleryId, galleryItemId: galleryItemId},
      crossDomain: true,
      headers: {'X-Requested-With':'XMLHttpRequest'},
      success: function (ret) {
        $(container).html(ret);
        $(demandedSelector).fancybox({
          padding: 5,
          margin: 5,
          prevEffect: 'fade',
          nextEffect: 'fade',
          helpers: {
            title: {
              type: 'inside'
            },
            thumbs: {
              width: 125,
              height: 75,
            }
          },
        }).click();
      }
    });
    //location.href = '/kep-galeriak/megosztott-' + galleryId;
  });
}

$(document).ready(function () {
  console.log("frontend: article ready");

  ArticlesIppInit();
  ArticlesGalleryLoaderInit()
});
